<template>
    <RestaurantFloor v-if="profile !== null" ref="floor" :profile="profile" />
    <div v-else class="card se-loading" aria-busy="true">
        <i class="pi pi-spin pi-spinner" style="font-size: 1.5rem;"></i>
    </div>
</template>

<script>
// La pantalla Salón (giro restaurante): las ventas abiertas por mesa y zona. Es su propio ítem de
// menú y su propia ruta, aparte de Ventas (permiso `restaurantTables`). El PERFIL de la pantalla de
// ventas (Capa 4, `screen-profile/get`, versión «Salón con mesas») trae su configuración: cocina,
// dividir el pago, zonas y totales. Un perfil nunca concede acceso.
import RestaurantFloor from './RestaurantFloor.vue';
import AppEventBus from '@/AppEventBus';
import { getScreenProfile } from '../../service/screenProfile';

export default {
    name: 'SalonEntry',
    components: { RestaurantFloor },
    data() {
        return { profile: null };   // null = cargando; {} = sin perfil (defaults)
    },
    async mounted() {
        await this.load();
        // Un admin cambió el perfil, o cambiaron los entitlements (plan/módulo): la configuración puede cambiar.
        this._reload = () => this.load(true);
        AppEventBus.on('screen_profiles_changed', this._reload);
        AppEventBus.on('entitlements_changed', this._reload);
    },
    beforeUnmount() {
        AppEventBus.off('screen_profiles_changed', this._reload);
        AppEventBus.off('entitlements_changed', this._reload);
    },
    // El salón pide confirmar si hay una distribución sin guardar; el guard de ruta vive en el
    // componente de la ruta (este), no en el hijo.
    beforeRouteLeave() {
        const floor = this.$refs.floor;
        return floor && floor.confirmLeave ? floor.confirmLeave() : true;
    },
    methods: {
        async load(force = false) {
            const res = await getScreenProfile('order-entry', 'web', { force });
            this.profile = (res && res.document) || {};
        },
    },
};
</script>

<style scoped>
.se-loading { display: flex; align-items: center; justify-content: center; min-height: 240px; color: var(--text-color-secondary); }
</style>
